import { useRef, useEffect, useState } from 'react';

const query = `
a[href]:not([tabindex='-1']),
area[href]:not([tabindex='-1']),
input:not([disabled]):not([tabindex='-1']),
select:not([disabled]):not([tabindex='-1']),
textarea:not([disabled]):not([tabindex='-1']),
button:not([disabled]):not([tabindex='-1']),
iframe:not([tabindex='-1']),
[tabindex]:not([tabindex='-1']),
[contentEditable=true]:not([tabindex='-1'])
`.trim();

type FocusTrapOptions = {
  active: boolean;
  onEscape?: () => void;
};

// TODO: focus trap is STILL broken
function useFocusTrap({ active, onEscape }: FocusTrapOptions = { active: true, onEscape: () => {} }) {
  const rootRef = useRef<HTMLElement | null>(null);
  const [focusableElements, setFocusableElements] = useState<HTMLElement[]>([]);

  const trapFocus = (el: HTMLElement | null) => {
    if (el) rootRef.current = el;
  };

  useEffect(() => {
    if (active && rootRef.current) {
      const elements = rootRef.current.querySelectorAll<HTMLElement>(query);
      setFocusableElements(Array.from(elements));
    }
  }, [active]);

  useEffect(() => {
    if (!active) return () => {};

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          lastElement.focus();
          event.preventDefault();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          firstElement.focus();
          event.preventDefault();
        }
      } else if (event.key === 'Escape' && onEscape) {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [active, focusableElements, onEscape]);

  return { trapFocus };
}

export default useFocusTrap;
